import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ObjectTypeDto} from "../../../../../core/cc/model/dto/entity/object-type.dto";
import {CbMetaEntityRole} from "../../../enum/cb-meta-entity-role.enum";

export class CbMetaEntityDto extends DtoDetail {

    public objectTypeDto: ObjectTypeDto;
    public objectTypeDtoId: number;
    public language: string;
    public description: string;
    public synonyms: string;
    public entityRole: CbMetaEntityRole;
    public locked: boolean;
    public canvasPositionX: number;
    public canvasPositionY: number;
}
